import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact';

/**
 * Custom hook to toggle all filter values for a facet at once
 * instead of looping through each value individually
 */
export function useToggleAllFilters() {
    const { updateSearch } = useActions();

    const toggleAllFilters = async (field, values, shouldSelectAll, currentFilters) => {
        // Keep all filters from other fields, update only this field
        const otherFilters = currentFilters.filter(f => f.field !== field);
        
        const updatedFilters = shouldSelectAll
            ? [...otherFilters, { field, value: values }]
            : otherFilters;
        
        await updateSearch({
            products: {
                filter: updatedFilters
            }
        });
    };

    return { toggleAllFilters };
}
